import type { ValidationErrorMessage } from '@festina/configuration-general-types/configuration'
import { ConfigurationRepositoryConfigurationCommandsService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationCommandsService'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation } from '@tanstack/react-query'

type PushWorkspaceProps = {
  server: ConfigurableServer
  workspaceName: string
}

type PushArguments = {
  description: string
}

/**
 * Pushes the workspace operations to its base branch. The workspace is deleted after a push, so no workspace
 * queries are invalidated here: refetching them would compete with the delete and the base branch refetches.
 */
export const usePushWorkspaceOperationsToConfigurationComponent = ({
  server,
  workspaceName,
}: PushWorkspaceProps) =>
  useMutation<void, ValidationErrorMessage, PushArguments>({
    mutationFn: ({ description }) =>
      ConfigurationRepositoryConfigurationCommandsService.configurationCommandServicePostPushWorkspace(
        {
          requestBody: {
            _type: 'WorkspacePushSpecification',
            workspaceName,
            changesetDescription: description,
            componentName: server.toLocaleLowerCase(),
          },
        },
      ),
  })
